module.exports = __webpack_public_path__ + "img/swimmers.8532faea.png";